import API from './utils/API'

const api = new API()
const prefix = '/app-feedback'

const sendFeedback = (data) =>
  api
    .callApi({
      url: `${prefix}/send`,
      method: 'post',
      data,
    })
    .then((result) => result.data.result)

export default {
  sendFeedback,
}
